import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useScopeCloses } from "@api/close.api";
import { formatFilterLabel } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const TaskCloseFilterLabel: React.FC<Props> = ({ filters }) => {
    const { data: closes = [] } = useScopeCloses();
    const { taskCloseIds } = filters;

    const labels = useMemo(
        () =>
            closes
                .filter((c) => taskCloseIds?.includes(c.id))
                .map((c) => c.name),
        [closes, taskCloseIds],
    );

    if (!taskCloseIds || taskCloseIds.length === 0) {
        return null;
    }

    return formatFilterLabel(labels);
};
